import { ProcessCipService } from '@app/src/views/CipGeneration/generateForm/models/ProcessCipService';
import { STATUS_CODE } from './constants';

export const hydrateProcessCip = (data: ProcessCipService) => {
  const dataHydrate = {
    code: data.code,
    message: data.message,
    cipUrl: ''
  };

  if (data['data'][0] && data['data'][0].message) {
    data.message = data['data'][0].message;
  }

  if(data.code === STATUS_CODE.OK) {
    dataHydrate.cipUrl = data.data.cipUrl;
  }
  return dataHydrate;
}
